class BESSAppProjectEditorInput extends BESSAppBase {

    static for(editor, item, field, isProjectWide = false) {
        let inputType = BESSAppProjectEditorReadOnlyInput;


        if (field.inputType === BESSAppInputType.map) {
            inputType = BESSAppProjectEditorMapField;
        }
        if (field.inputType === BESSAppInputType.labelOnly) {
            inputType = BESSAppProjectEditorInputLabelOnly;
        }

        if (!field.isReadOnly) {
            inputType = BESSAppProjectEditorInputField;

            if (isProjectWide) {
                inputType = BESSAppProjectWideInputField;
            } else {

                switch (field.inputType) {
                    case BESSAppInputType.choice:
                        inputType = BESSAppProjectEditorChoiceField;
                        break;
                    case BESSAppInputType.boolean:
                        inputType = BESSAppProjectEditorRadioField;
                        break;
                    case BESSAppInputType.quantity:
                        inputType = BESSAppProjectEditorQuantityInputField;
                        break;
                    case BESSAppInputType.percentage:
                        inputType = BESSAppProjectEditorPercentageInputField;
                        break;
                    case BESSAppInputType.measurement:
                        inputType = BESSAppProjectEditorMeasurementInputField;
                        break;
                    case BESSAppInputType.textarea:
                        inputType = BESSAppProjectEditorTextAreaField;
                        break;
                    case BESSAppInputType.tags:
                        inputType = BESSAppProjectEditorTagsInputField;
                        break;
                    case BESSAppInputType.hidden:
                        inputType = BESSAppProjectEditorHidden;
                        break;

                }
            }
        }

        return new inputType(editor, item, field);
    }

    constructor(editor, item, field) {
        super();
        this.editor = editor;
        this.item = item;
        this.field = field;
        this.changeFns = [];
        this.changeRuleFns = [];
        this.value = this.item.values[this.field.fieldNo];
        this.localValue = null;
        this.displayValue = this.value.displayValue(this.field);
        this.readOnlyDisplayValue = this.value.displayValue(this.field, '&nbsp;');
        this._validators = [];
        this.input = null;
        this.required = null;
    }

    build() {
        this.view = this.buildView();
        this.view.attr('data-input-type', this.field.inputType);
        return this.view;
    }

    initialise() {
        if (this.field.dependencies.length > 0) {
            this.dependentView = new BESSAppDependentView(
                this.view.parents('.app-editor-field'),
                this.field.dependencies,
                {
                    item: this.item
                },
                this.onFieldDependencyChanged.bind(this),
            );
        }
        let fieldView = this.view.parents('.app-editor-field');
        if (!fieldView.hasClass('dependency-hidden')) {
            fieldView.hideIf(!this.value.isApplicable);
        }

        this.fireEvent(new BESSAppQuestionAnswerDependencyEvent(this.item, this.field, this.value), true);
        this.fireEvent(new BESSAppItemQuestionAnswerDependencyEvent(this.item, this.field, this.value), true);
    }

    onFieldDependencyChanged(isAvailable, value) {

    }

    containerClass() {
        return 'app-project-editor-input-readonly';
    }

    buildView() {
        return $('<div class="app-orig-value">' + this.readOnlyDisplayValue + '</div>');
    }

    onChange(changeFn) {
        this.changeFns.push(changeFn);
    }

    addChangeRule(changeRuleFn) {
        this.changeRuleFns.push(changeRuleFn);
    }

    _onChanged(value) {
        let propagate = true;
        this.forEach(this.changeRuleFns, function (x) {
            if (!x(value)) {
                propagate = false;
            }
        });
        if (propagate) {
            this.forEach(this.changeFns, function (x) {
                x(value);
            });
            this.fireChangedEvents();
        }
    }

    fireChangedEvents() {
        this.fireEvent(new BESSAppQuestionAnswerDependencyEvent(this.item, this.field, this.value, true));
        this.fireEvent(new BESSAppItemQuestionAnswerDependencyEvent(this.item, this.field, this.value, true));
    }

    _getInputValue() {
        return this.value;
    }

    _inputChanged() {
        this.storeLocalValue(this._getInputValue());
    }

    getValue(defaultValue) {
        defaultValue = nullIfUndefined(defaultValue);
        let val;
        if (this.localValue !== null) {
            val = this.localValue;
        } else {
            val = this.value.value;
        }
        if (!val && defaultValue != null) {
            return defaultValue;
        }
        return val;
    }

    setValue(value) {
        this.storeLocalValue(value);
    }

    clear() {
        this.setValue('');
    }

    storeLocalValue(value) {
        if (!this.field.isReadOnly) {
            if (this.value === null || this.setValueIsChanged(value)) {
                this.localValue = value;
            } else {
                this.localValue = null;
            }
            this.value.value = this._toDataValue(value);
            this._onChanged(this.localValue);
            this.editor.updateState();
        }
    }

    setValueIsChanged(value) {
        return value !== this.displayValue;
    }

    hasChanged() {
        return this.localValue != null;
    }

    focus() {
        return false;
    }

    hasValue() {
        return true;
    }

    setIsRequired(isRequired) {
        this.required = isRequired;
        this.input.parents('.app-editor-field').find('.app-item-label-required').hideIf(!isRequired);
    }

    isRequired() {
        if (this.required != null) {
            return this.required;
        }
        return this.field.isRequired;
    }

    isValid() {
        return this.validate() == null;
    }

    validate() {
        let result = null;
        _.forEach(this._validators, function (rule) {
            if (result === null) {
                result = rule(this, this.value.value);
            }
        }.bind(this));
        return result;
    }

    markValid() {
    }

    markInvalid(reason) {
    }

    isHidden() {
        return this.view.parents('.app-editor-field').isHidden();
    }

    addValidator(validator) {
        this._validators.push(validator);
    }

    _toDataValue(value) {
        return value;
    }

    hideIf(condition) {
        this.view.parents('.app-editor-field').addClassIf('invisible', condition);
    }
}

class BESSAppProjectEditorReadOnlyInput extends BESSAppProjectEditorInput {

    setValue(value) {
        super.setValue(value);
        this.view.text(value);
    }
}

class BESSAppProjectEditorHidden extends BESSAppProjectEditorReadOnlyInput {

    initialise() {
        super.initialise();
        this.view.parents('.app-editor-field').addClassIf('invisible', true);
    }

    hideIf(condition) {
    }
}